import { render, staticRenderFns } from "./PrivateImageSelect.vue?vue&type=template&id=1ecfc259&scoped=true&"
import script from "./PrivateImageSelect.vue?vue&type=script&lang=js&"
export * from "./PrivateImageSelect.vue?vue&type=script&lang=js&"
import style0 from "./PrivateImageSelect.vue?vue&type=style&index=0&id=1ecfc259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecfc259",
  null
  
)

export default component.exports